
export default class MyAccountLogin {

    private readonly customerLoginDescription: HTMLButtonElement | null = document.querySelector('.choose-login') as HTMLButtonElement;
    private readonly customerRegisterDescription: HTMLButtonElement | null = document.querySelector('.choose-register') as HTMLButtonElement;
    private readonly customerLoginButton: HTMLButtonElement | null = this.customerLoginDescription?.querySelector('.open-customer-login') as HTMLButtonElement;
    private readonly customerRegisterButton: HTMLButtonElement | null = this.customerRegisterDescription?.querySelector('.open-customer-register') as HTMLButtonElement;
    private readonly customerLoginForm: HTMLButtonElement | null = document.querySelector('.customer-login') as HTMLButtonElement;
    private readonly customerRegisterForm: HTMLButtonElement | null = document.querySelector('.customer-register') as HTMLButtonElement;
    private mobileView: Boolean = innerWidth <= 991;

    async init(): Promise<void> {
        this.registerShowLoginFormEvent()
        this.registerShowRegisterFormEvent()

        if (this.mobileView) {
            this.registerShowLoginFormMobileEvent()
            this.registerShowRegisterFormMobileEvent()
        }

        if (document.querySelector('.woocommerce-notices-wrapper .woocommerce-error'))
            this.customerLoginButton?.click()
    }

    async registerShowLoginFormEvent(): Promise<void> {

        this.customerLoginButton?.addEventListener('click', e => {

            this.showLoginForm()
            this.hideRegisterForm()

            this.showRegisterDescription()
            this.hideLoginDescription()

            if (this.mobileView) this.hideRegisterDescription()
            if (this.mobileView) this.removeMobileElement()
        })
    }

    async registerShowRegisterFormEvent(): Promise<void> {
        this.customerRegisterButton?.addEventListener('click', e => {

            this.showRegisterForm()
            this.hideLoginForm()

            this.hideRegisterDescription()
            this.showLoginDescription()

            if (this.mobileView) this.hideLoginDescription()
            if (this.mobileView) this.removeMobileElement()
        })
    }

    async registerShowLoginFormMobileEvent(): Promise<void> {
        this.customerLoginForm?.querySelector('.back-to-register')?.addEventListener('click', e => {
            this.customerRegisterButton?.click()
            this.removeMobileElement()
        })
    }

    async registerShowRegisterFormMobileEvent(): Promise<void> {
        this.customerRegisterForm?.querySelector('.back-to-login')?.addEventListener('click', e => {
            this.customerLoginButton?.click()
            this.removeMobileElement()
        })
    }

    // login form
    async showLoginForm(): Promise<void> {
        this.customerLoginForm?.classList.remove('!hidden')
    }
    async hideLoginForm(): Promise<void> {
        this.customerLoginForm?.classList.add('!hidden')
    }

    // register form
    async showRegisterForm(): Promise<void> {
        this.customerRegisterForm?.classList.remove('!hidden')
    }
    async hideRegisterForm(): Promise<void> {
        this.customerRegisterForm?.classList.add('!hidden')
    }

    // register description
    async showRegisterDescription(): Promise<void> {
        this.customerRegisterDescription?.classList.remove('!hidden')
        this.customerLoginDescription?.classList.remove('rounded')
    }
    async hideRegisterDescription(): Promise<void> {
        this.customerRegisterDescription?.classList.add('!hidden')
    }

    // login description
    async showLoginDescription(): Promise<void> {
        this.customerLoginDescription?.classList.remove('!hidden')
        this.customerLoginDescription?.classList.add('rounded')
    }
    async hideLoginDescription(): Promise<void> {
        this.customerLoginDescription?.classList.add('!hidden')
        this.customerRegisterDescription?.classList.add('rounded')
    }

    // hide mobile
    async removeMobileElement(): Promise<void> {
        document.querySelectorAll('.mobile-hide')?.forEach(el => { el.remove() })
    }

} 